var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_messages copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20.384408 0 20.384408 19.9578759 0 19.9578759"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_messages-copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(7.615592, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28963124,2.12645846 C2.6481496,2.12645846 2.12645846,2.64850401 2.12645846,3.28963124 L2.12645846,12.7895844 C2.12645846,13.4307116 2.6481496,13.9527572 3.28963124,13.9527572 L11.0848735,13.9527572 C11.4754331,13.9527572 11.8592588,14.0860152 12.1654688,14.3277227 L12.2076436,14.3624548 L15.6415196,17.3689127 L15.6415196,15.6978708 C15.6415196,14.7356483 16.4244107,13.9527572 17.3866332,13.9527572 C17.8672128,13.9527572 18.2581267,13.5618432 18.2581267,13.0812636 L18.2581267,3.28963124 C18.2581267,2.64850401 17.7364356,2.12645846 17.094954,2.12645846 L3.28963124,2.12645846 Z M16.0200292,19.9578759 C15.6365579,19.9578759 15.2576939,19.829934 14.9415604,19.5804295 L14.9000944,19.5456973 L10.9402744,16.0792156 L3.28963124,16.0792156 C1.47576217,16.0792156 0,14.6034535 0,12.7895844 L0,3.28963124 C0,1.47576217 1.47576217,0 3.28963124,0 L17.094954,0 C18.908823,0 20.3845852,1.47576217 20.3845852,3.28963124 L20.3845852,13.0812636 C20.3845852,14.6052255 19.2416138,15.8672786 17.7679781,16.0551158 L17.7679781,18.2106358 C17.7679781,18.8850776 17.3908861,19.4868653 16.7837822,19.7810254 C16.5392395,19.8993983 16.2787483,19.9578759 16.0200292,19.9578759 L16.0200292,19.9578759 Z",
    id: "Fill-1",
    fill: "#516983",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.36455599,27.5733616 C4.10548247,27.5733616 3.84463689,27.5152384 3.60009417,27.3965111 C2.99334469,27.102351 2.61625272,26.5005633 2.61625272,25.8261215 L2.61625272,23.6706015 C1.14261701,23.4827643 0,22.2207112 0,20.6971037 L0,10.9051169 C0,9.09124785 1.47576217,7.61548568 3.28963124,7.61548568 L5.37391494,7.61548568 C5.96117188,7.61548568 6.43714417,8.09110356 6.43714417,8.67871491 C6.43714417,9.26597185 5.96117188,9.74194414 5.37391494,9.74194414 L3.28963124,9.74194414 C2.6481496,9.74194414 2.12645846,10.2636353 2.12645846,10.9051169 L2.12645846,20.6971037 C2.12645846,21.1773289 2.51737241,21.5685973 2.99795202,21.5685973 C3.95982006,21.5685973 4.74271118,22.3514884 4.74271118,23.3133564 L4.74271118,24.9843984 L8.21876195,21.9432084 C8.52532637,21.7018553 8.90915213,21.5685973 9.29935725,21.5685973 L17.094954,21.5685973 C17.7364356,21.5685973 18.2581267,21.0465517 18.2581267,20.4050701 L18.2581267,19.1848373 C18.2581267,18.5975804 18.734099,18.1216081 19.321356,18.1216081 C19.9086129,18.1216081 20.3845852,18.5975804 20.3845852,19.1848373 L20.3845852,20.4050701 C20.3845852,22.2192936 18.908823,23.6950557 17.094954,23.6950557 L9.44431084,23.6950557 L5.44231602,27.196624 C5.12618253,27.445774 4.74767292,27.5733616 4.36455599,27.5733616",
    id: "Fill-4",
    fill: "#516983"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessages);
export default __webpack_public_path__ + "static/media/icon_messages.aae0de5051cc0a7b4ac95c4f30aebc1f.svg";
export { ForwardRef as ReactComponent };